
    import { Component } from 'vue-property-decorator';
    import ListBase from '@/lib/listbase';
    import FormBase from '@/components/helper/form-base.vue';
    import Util from '@/lib/util'
    import url from '@/lib/url'
    import Quiz from '@/store/entities/cems/quiz';
    import Sale from '@/store/entities/cems/sale';

    @Component({
        components: { FormBase },
    })
    export default class PublicForm extends ListBase {
        name: string = 'publicForm';
        sale: Sale = new Sale();
        quiz: Quiz = new Quiz();
        selectedItem: any = null;
        valid: boolean = false;       
        send: boolean = false;       


        /***** COMPUTED METHODS *****/
        get questions() {
            return Util.abp.list.getList('QUESTIONS');
        }       

        get loadingSale() {
            return this.$store.state.sale.loading;
        }

        get loading() {
            return this.$store.state.quiz.loading;
        }

        /***** EVENTS *****/    
        async saveQuiz() {
            if ((this.$refs.vform as any).validate()) {
                let model = Util.extend(true, {}, this.quiz);
                model.questions = this.questions;
                model.sale_id = this.sale.id;

                await this.$store.dispatch({
                    type: 'quiz/create',
                    data: model
                });

                this.send = true;
                this.$swal(this.L('Respuestas Enviadas'), this.L('Muchas gracias por tu participacion!'), 'success');
            }
        }

        /***** FUNCIONES DE INTERFACE *****/
        getInitials(string) {
            return Util.getInitials(string);
        }


        /***** INIT EVENTS *****/
        async loadSale() {
            let model = await this.$store.dispatch({
                type: 'sale/get',
                id: this.$route.query.sale
            });
            this.sale = Util.extend(true, {}, model);
            this.send = this.sale['quiz_send'];
        }

        async mounted() {
            this.$store.commit('quiz/new');
            this.send = false;
            await this.loadSale();
        }

        created() {
        }

    }
